import { render, staticRenderFns } from "./SampleDetail.vue?vue&type=template&id=649636a8&scoped=true"
import script from "./SampleDetail.vue?vue&type=script&lang=js"
export * from "./SampleDetail.vue?vue&type=script&lang=js"
import style0 from "./SampleDetail.vue?vue&type=style&index=0&id=649636a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649636a8",
  null
  
)

export default component.exports